import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { LabelService } from '../../services/label.service';
import { PatientReminder } from '../../models/patient-model';
import { PatientService } from '../../services/patient.service';
import { Subject, takeUntil } from 'rxjs';
import { ErrorPanelService } from '../../services/error-panel.service';
import { ConfirmationPanelComponent } from '../confirmation-panel/confirmation-panel.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-patient-reminders',
  standalone: false,
  templateUrl: './patient-reminders.component.html',
  styleUrl: './patient-reminders.component.scss',
})
export class PatientRemindersComponent implements OnInit {
  @Input() patientId: string = '';
  @Input() isMobile: boolean = false;
  @Input() reminders: PatientReminder[] = [];
  @Input() filteredReminders: PatientReminder[] = [];
  @Output() switchPanels = new EventEmitter<void>();
  @Output() changesInReminders = new EventEmitter<void>();

  showAddReminderPanel: boolean = false;
  showFilterReminderPanel: boolean = false;
  showUpdateReminderPanel: boolean = false;
  showDeleteReminderPanel: boolean = false;

  selectedReminder: PatientReminder = {
    id: '',
    patientId: '',
    description: '',
    completed: false,
    dateLastModified: '',
  };

  filtersForReminders: string[] = ['Non completati', 'Tutti'];
  selectedFilterForReminders: string = 'Non completati';

  constructor(
    public labelService: LabelService,
    private patientService: PatientService,
    public errorPanelService: ErrorPanelService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.handleFilterSelect('Non completati');
  }

  switchSectionMobile() {
    this.switchPanels.emit();
  }

  handleFilterSelect(filter: string) {
    this.selectedFilterForReminders = filter;
    if (filter === 'Tutti') {
      this.filteredReminders = this.reminders;
    }
    if (filter === 'Non completati') {
      this.filteredReminders = this.reminders.filter(
        (reminder) => !reminder.completed
      );
    }
  }

  toggleAddReminderPanel(): void {
    this.showAddReminderPanel = !this.showAddReminderPanel;
  }

  toggleUpdateReminderPanel(reminder?: PatientReminder): void {
    if (reminder) {
      this.selectedReminder = reminder;
    } else {
      this.selectedReminder = {
        id: '',
        patientId: '',
        dateLastModified: '',
        description: '',
        completed: false,
      };
    }
    this.showUpdateReminderPanel = !this.showUpdateReminderPanel;
  }

  checkReminder(reminder: PatientReminder) {
    reminder.completed = !reminder.completed;
    const obj = {
      patient_id: this.patientId,
      description: reminder.description,
      completed: reminder.completed,
    };
    this.patientService.updateReminder(reminder.id, obj).subscribe({
      next: (response) => {
        console.log('Promemoria aggiornato');
      },
      error: (error) => {
        console.error('Qualcosa è andato storto', error);
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'aggiornare il promemoria"
        );
      },
    });
  }

  createNewReminder(text: string) {
    const obj = {
      patient_id: this.patientId,
      description: text,
      completed: false,
    };
    this.patientService.createReminder(obj).subscribe({
      next: (response) => {
        this.toggleAddReminderPanel();
        this.changesInReminders.emit();
      },
      error: (error) => {
        console.error('Qualcosa è andato storto', error);
        this.toggleAddReminderPanel();
        this.errorPanelService.showErrorSnackBar(
          'Errore nel creare il promemoria'
        );
      },
    });
  }

  updateReminder(text: string) {
    this.selectedReminder.description = text;
    const obj = {
      patient_id: this.patientId,
      description: text,
      completed: false,
    };
    this.patientService
      .updateReminder(this.selectedReminder.id, obj)
      .subscribe({
        next: (response) => {
          this.toggleUpdateReminderPanel();
          this.changesInReminders.emit();
        },
        error: (error) => {
          console.error('Qualcosa è andato storto', error);
          this.toggleUpdateReminderPanel();
          this.errorPanelService.showErrorSnackBar(
            'Errore nellaggiornare il promemoria'
          );
        },
      });
  }

  deleteReminder(reminder: PatientReminder) {
    const dialogRef = this.dialog.open(ConfirmationPanelComponent, {
      data: {
        title: 'Sei sicuro di voler eliminare questo promemoria?',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.patientService.deleteReminder(reminder.id).subscribe({
          next: (response) => {
            this.reminders = this.reminders.filter(
              (reminder) => reminder.id !== this.selectedReminder.id
            );
            this.changesInReminders.emit();
          },
          error: (error) => {
            console.error('Qualcosa è andato storto', error);
            this.errorPanelService.showErrorSnackBar(
              "Errore nell'eliminare il promemoria"
            );
          },
        });
      } else {
        console.log('Eliminazione annullata');
      }
    });
  }
}
